import { Avatar, Badge, Group, Paper, Stack, Text } from '@mantine/core';
import React from 'react';
import { Conversation, ConversationParticipant } from '../../../models/chat';
import { formatLocale } from '../../../providers/dayjs-plugins';
import { getFullNameInitials } from '../../../utils/get-full-name-initials';
import { clickablePaperSx } from '../styles';

interface ConversationItemProps {
  conv: Conversation;
  userId?: number;
  onSelect: (id: number) => void;
}

export const ConversationItem = React.memo(function ConversationItem({
  conv,
  userId,
  onSelect,
}: ConversationItemProps) {
  const otherParticipant =
    conv.type === 'group'
      ? null
      : conv.participants.find(
          (p: ConversationParticipant) => p.user.id !== userId,
        );
  const lastMsg = conv.lastMessage;

  return (
    <Paper
      withBorder
      p="xs"
      sx={clickablePaperSx}
      onClick={() => onSelect(conv.id)}
    >
      <Group position="apart" noWrap>
        <Group spacing="xs" noWrap sx={{ flex: 1 }}>
          <Avatar
            src={
              conv.type === 'group'
                ? undefined
                : otherParticipant?.user.avatarUrl
            }
            size="sm"
            radius="xl"
            color={conv.type === 'group' ? 'cyan' : 'blue'}
          >
            {conv.type === 'group'
              ? getFullNameInitials(conv.name || 'Grupo')
              : !otherParticipant?.user.avatarUrl &&
                getFullNameInitials(
                  otherParticipant?.user.username || 'Conversa',
                )}
          </Avatar>
          <Stack spacing={0} sx={{ flex: 1 }}>
            <Group spacing="xs" noWrap>
              <Text weight={500} size="sm" lineClamp={1}>
                {conv.type === 'group'
                  ? conv.name || 'Grupo'
                  : otherParticipant?.user.username ?? 'Conversa ' + conv.id}
              </Text>
              {(conv.unreadCount ?? 0) > 0 && (
                <Badge size="xs" color="blue" variant="filled" radius="xl">
                  {conv.unreadCount}
                </Badge>
              )}
            </Group>
            {lastMsg && (
              <Text size="xs" color="dimmed" lineClamp={1}>
                {lastMsg.content}
              </Text>
            )}
          </Stack>
        </Group>
        {lastMsg && (
          <Text size="xs" color="dimmed" sx={{ whiteSpace: 'nowrap' }}>
            {formatLocale(lastMsg.createdAt, 'HH:mm')}
          </Text>
        )}
      </Group>
    </Paper>
  );
});
